export class AccordionCompositeParams {

  public constructor(public confId: number, public reload: boolean) {

  }


}